export default "__VITE_ASSET__PTdKVa7n__"